import React, { useState, useEffect } from 'react';
import Logo from "../../assets/images/auth-logo.png";
import { Card, Flex, Image, Typography } from 'antd';
import CustomButton from '../../components/CustomButton/Button';
import IndividualIcon from '../../assets/icons/individualIcon.svg';
import CompanyIcon from '../../assets/icons/companyIcon.svg';
import HufIcon from '../../assets/icons/hufIcon.svg';
import './Signup.scss';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { getAllBusinessTypes } from '../../redux/slices/AuthSlice';
import Loader from "../../components/CustomLoader/Loader"
import { BTN_TXT, TITLE_TXT } from '../../constants/constants';

const { Title } = Typography;

const icons = {
    Individual: IndividualIcon,
    Company: CompanyIcon,
    HUF: HufIcon,
};

const EnrollAs = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { businessTypes, loading } = useSelector((state) => state.auth);
    const [selectedCard, setSelectedCard] = useState(null);

    useEffect(() => {
        dispatch(getAllBusinessTypes());
    }, [dispatch]);

    const handleCardSelect = (type) => {
        setSelectedCard(type);
    };

    const isSelected = (type) => selectedCard?.businessTypeName === type;

    const handleNext = () => {
        navigate('/signup', { state: { signupType: selectedCard.businessTypeId } });
    };

    return (
        <>
            {loading ? <Loader /> : (
                <div className='auth-container'>
                    <div className="logo">
                        <Image preview={false} src={Logo} alt="Logo" />
                    </div>

                    <Title className="signup-as-text">{TITLE_TXT.ENROLL_AS}</Title>

                    <Flex vertical gap="large" className='signup-type-cards-container'>
                        {businessTypes.map((type) => (
                            <Card
                                key={type.businessTypeId}
                                className={`signup-type-card ${isSelected(type.businessTypeName) ? 'selected' : ''}`}
                                onClick={() => handleCardSelect(type)}
                            >
                                <Flex align="center" justify="flex-start" gap={15}>
                                    <Image
                                        src={icons[type.businessTypeName] || IndividualIcon}
                                        preview={false}
                                        alt={type.businessTypeName}
                                    />
                                    <Typography style={{ fontWeight: isSelected(type.businessTypeName) ? 'bold' : '400' }}>
                                        {type.businessTypeName}
                                    </Typography>
                                </Flex>
                            </Card>
                        ))}
                    </Flex>

                    <CustomButton type="primary" block disabled={!selectedCard} onClick={handleNext}>
                        {BTN_TXT.NEXT}
                    </CustomButton>
                </div>
            )}
        </>

    );
};

export default EnrollAs;
